<template>
<div class="chapter">
<div class="inner_page">
<p class="C492"><em><strong><span id="id_9">Dwight </span>Yoakam </strong></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Half_Tit.vue?28cb55b9